<ng-template #content>
  <div class="zef-code-p1" [class.single-line]="!multiLine">
    <ng-content></ng-content>
  </div>
</ng-template>

@if (!multiLine) {
  <div class="zef-scroll-x">
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </div>
} @else {
  <ng-template [ngTemplateOutlet]="content"></ng-template>
}

@if (copyContent) {
  <button
    [zefCopyToClipboard]="copyContent"
    [copyToClipboardNotice]="copyToClipboardNotice"
    [copyToClipboardAction]="copyToClipboardAction"
    [copyToClipboardActionName]="copyToClipboardActionName"
    color="ink"
    class="zef-ghost-button"
    mat-icon-button
  >
    <mat-icon>action_copy</mat-icon>
  </button>
}
